import React, { ReactElement } from "react";

interface IProps {
  onClick: (typeCatalog: string) => void;
  catalog: string;
}

const FilterButtons = ({ onClick, catalog }: IProps): ReactElement => {
  const buttons = [
    { id: "all", name: "Все" },
    { id: "recent", name: "Недавнее" },
    { id: "favorites", name: "Избранное" },
  ];

  return (
    <div className="netw__panel filter-panel">
      {buttons.map((item) => {
        return (
          <button
            className={`btn filter-panel__btn ${
              catalog === item.id ? "filter-panel__btn--active" : ""
            }`}
            key={item.id}
            type="button"
            onClick={() => onClick(item.id)}
          >
            {item.name}
          </button>
        );
      })}
    </div>
  );
};

export default FilterButtons;
